import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { BodyRouteParamsRequest } from '#models';
import type { MessageDataObject } from '#models/services';
import { routes } from '#routes';

type CreateChatroomMessageRequestBody =
  paths['/chatrooms/{chatroomId}/messages']['post']['requestBody']['content']['application/json'];
type CreateChatroomMessageRouteParameters = paths['/chatrooms/{chatroomId}/messages']['post']['parameters']['path'];

export const createChatroomMessage = async ({
  body,
  routeParams: { chatroomId },
}: BodyRouteParamsRequest<CreateChatroomMessageRequestBody, CreateChatroomMessageRouteParameters>) =>
  getNodeApiAxiosInstance().post<MessageDataObject, AxiosResponse<MessageDataObject>>(
    routes.chatrooms.messages.create(chatroomId),
    body,
  );
